/** Extract a human-readable message from an axios/fetch error (pure, testable). */
export function getApiErrorMessage(err: unknown, fallback = 'Something went wrong'): string {
  if (!err) return fallback;
  if (typeof err === 'string') return err.trim() || fallback;
  if (typeof err !== 'object') return fallback;

  const e = err as { response?: { data?: unknown; status?: number }; message?: unknown };
  const data = e.response?.data;

  if (data && typeof data === 'object') {
    const d = data as { error?: unknown; message?: unknown };
    if (typeof d.error === 'string' && d.error.trim()) return d.error;
    if (typeof d.message === 'string' && d.message.trim()) return d.message;
  } else if (typeof data === 'string' && data.trim() && !data.trim().startsWith('<')) {
    return data.trim();
  }

  // No usable server body. Only surface the client message when there was no
  // HTTP response at all (network error, timeout); axios' generic
  // "Request failed with status code N" is not helpful to users.
  if (!e.response && typeof e.message === 'string' && e.message.trim()) return e.message;
  return fallback;
}

/** Machine-readable error code from the API body (`{ code }`), if any. */
export function getApiErrorCode(err: unknown): string | null {
  if (!err || typeof err !== 'object') return null;
  const data = (err as { response?: { data?: unknown } }).response?.data;
  if (!data || typeof data !== 'object') return null;
  const code = (data as { code?: unknown }).code;
  return typeof code === 'string' && code ? code : null;
}

export function getApiErrorStatus(err: unknown): number | null {
  if (!err || typeof err !== 'object') return null;
  const status = (err as { response?: { status?: unknown } }).response?.status;
  return typeof status === 'number' ? status : null;
}
